import { useState } from "react";
import type { ReactNode } from "react";

interface FAQItem {
  id: number;
  question: string;
  answer: ReactNode;
  category: string;
}

const faqData: FAQItem[] = [
  // Infos pratiques — en premier
  {
    id: 10,
    category: "Infos pratiques",
    question: "Comment se rendre au lieu de départ de votre aventure ?",
    answer:
      <>
        Nos véhicules sont disponibles à Versailles, proche des gares de{" "}
        <a
          href="https://me-deplacer.iledefrance-mobilites.fr/itineraire/resultat?departure=%7CCoord%7CMa+position%7C%7C%7C629612.6805729648%7C2589169.0011965036&arrival=stop_area%3AIDFM%3A63880%7CStopArea%7CVersailles+Chantiers%7C78000%7CVersailles%7C585217.1354389676%7C2421931.965422447&date=2026-03-24T10%3A45&journeyProfil=00&sens=1"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#1E585A] underline font-semibold hover:opacity-70"
        >
          Versailles-Chantiers
        </a>{" "}
        à seulement 12 minutes de Paris Montparnasse en Transilien/TER et{" "}
        <a
          href="https://me-deplacer.iledefrance-mobilites.fr/itineraire/resultat?arrival=stop_area%3AIDFM%3A73721%7CStopArea%7CVersailles%20Ch%C3%A2teau%20Rive%20Gauche%7C78000%7CVersailles%7C584749.0017073108%7C2422387.355360825%7C78646%7C%7Cprovider1&departure=%7CCoord%7CMa%20position%7C%7C%7C629612.6805729648%7C2589169.0011965036%7C%7C%7C&journeyProfil=10&date=2026-03-24T09:45:00.000Z&sens=1&preferences=1111111|11"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#1E585A] underline font-semibold hover:opacity-70"
        >
          Versailles-Château-Rive-Gauche
        </a>{" "}
        à 25 minutes du centre de Paris via le RER C. Un emplacement idéal pour démarrer votre aventure sans stress, même si vous venez sans voiture.
        En voiture, l'adresse du lieu de rendez-vous vous sera communiquée quelques jours avant votre départ.
      </>,
  },

  // Réservation & fonctionnement
  {
    id: 1,
    category: "Réservation & fonctionnement",
    question: "Peut-on réserver directement sur votre site ? Sur quelles plateformes êtes-vous présents ?",
    answer:
      "La réservation s'effectue directement sur nos plateformes partenaires : Wikicampers, Yescapa, Getaround, Roadstr ou Turo. Notre site vous permet de découvrir nos véhicules et de cliquer vers la plateforme de votre choix. Chaque plateforme a ses propres conditions, tarifs et options d'assurance — à vous de choisir celle qui vous convient le mieux. Vous pouvez également nous contacter via notre formulaire si vous avez des questions avant de réserver.",
  },
  {
    id: 2,
    category: "Réservation & fonctionnement",
    question: "Comment se passe la réservation concrètement ?",
    answer:
      "C'est simple : parcourez nos véhicules sur le site, puis cliquez sur la plateforme de votre choix (Wikicampers, Yescapa, Getaround, Roadstr ou Turo). Vous finalisez la réservation directement sur la plateforme, qui gère le paiement et le contrat. Dix jours avant votre départ, nous vous envoyons par e-mail l'inventaire complet du véhicule ainsi qu'un petit manuel d'utilisation des équipements.",
  },
  {
    id: 3,
    category: "Réservation & fonctionnement",
    question: "Les prix sont-ils visibles sur votre site ?",
    answer:
      "Les tarifs sont affichés directement sur chaque plateforme partenaire. Ils peuvent varier selon la période, la durée de location et les options choisies. N'hésitez pas à comparer les plateformes — les prix et conditions peuvent différer légèrement de l'une à l'autre.",
  },
  {
    id: 5,
    category: "Réservation & fonctionnement",
    question: "Peut-on vous contacter directement avant de réserver ?",
    answer:
      "Absolument. Si vous avez des questions sur un véhicule, ses équipements ou votre projet de voyage, utilisez notre formulaire de contact sur le site. Nous sommes également joignables par téléphone. Nous sommes là pour vous aider à choisir le van qui correspond à votre aventure.",
  },

  // Les véhicules
  {
    id: 6,
    category: "Les véhicules",
    question: "Quel permis faut-il pour conduire vos vans ?",
    answer:
      "Un simple permis B suffit pour tous nos véhicules. Nos vans sont des véhicules de moins de 3,5 tonnes, accessibles à tous les conducteurs titulaires du permis de conduire classique. Pas de permis spécifique, pas de surprise.",
  },
  {
    id: 7,
    category: "Les véhicules",
    question: "Quels équipements sont inclus dans les vans ?",
    answer:
      "Chaque véhicule dispose de ses propres équipements inclus (ustensiles de cuisine, douche solaire, et bien d'autres selon le van). Des équipements supplémentaires sont également disponibles sur demande : vélos, linge de maison (draps, couettes, oreillers)... Dix jours avant votre départ, vous recevrez par e-mail l'inventaire complet du véhicule ainsi qu'un manuel d'utilisation des équipements techniques. N'hésitez pas à nous appeler si vous avez des questions spécifiques avant de réserver.",
  },
  {
    id: 8,
    category: "Les véhicules",
    question: "Proposez-vous des véhicules électriques ou écologiques ?",
    answer:
      "La van life est en elle-même une façon de voyager plus proche de la nature : on vit dehors, on ralentit, on consomme différemment. C'est cette philosophie que nous partageons. Certains de nos véhicules sont électriques et vont encore plus loin dans cette démarche — plus silencieux, plus respectueux de l'environnement, sans compromis sur le confort. Pas de greenwashing : juste des gens qui aiment la nature et ce qu'elle nous apprend.",
  },
  {
    id: 9,
    category: "Les véhicules",
    question: "Vos véhicules sont-ils entretenus entre chaque location ?",
    answer:
      "Oui, systématiquement. Chaque véhicule fait l'objet d'un nettoyage complet et d'une vérification technique entre chaque location. Vous partez avec un van en parfait état — c'est notre engagement.",
  },

  // Conditions de location
  {
    id: 11,
    category: "Conditions de location",
    question: "Le kilométrage est-il limité ?",
    answer:
      "Les conditions de kilométrage dépendent de la plateforme choisie. En général, un forfait de 100 km/jour est inclus, avec la possibilité de passer à une option 200 km/jour. Vérifiez les détails directement sur la plateforme au moment de votre réservation.",
  },
  {
    id: 12,
    category: "Conditions de location",
    question: "Les animaux de compagnie sont-ils acceptés ?",
    answer:
      "Les animaux sont acceptés sur demande. Contactez-nous par téléphone avant votre réservation pour en discuter. En cas de dégradation liée à votre animal, un forfait nettoyage supplémentaire pourra être appliqué.",
  },
  {
    id: 13,
    category: "Conditions de location",
    question: "Dans quel état doit-on rendre le véhicule ?",
    answer:
      "Le van doit être rendu dans l'état dans lequel vous l'avez reçu : propre intérieur et extérieur, avec le même niveau de carburant ou de batterie qu'au départ. Des lingettes et un produit de nettoyage sont fournis à bord pour faciliter la remise en état. Pour le nettoyage extérieur, le passage au portique à rouleaux est interdit — nous vous recommandons le lavage haute pression. Les coordonnées GPS des stations de lavage locales vous seront communiquées avant votre retour. Un état des lieux est réalisé à la remise et au retour des clés.",
  },

  // Assurance & assistance
  {
    id: 14,
    category: "Assurance & assistance",
    question: "Qui gère les assurances pendant la location ?",
    answer:
      "Les assurances sont gérées par la plateforme sur laquelle vous avez réservé (Wikicampers, Yescapa, Getaround, Roadstr ou Turo). Chaque plateforme propose plusieurs niveaux de couverture avec des valeurs de franchise variables, adaptés à vos besoins. Nous vous recommandons de bien lire les conditions d'assurance avant de finaliser votre réservation.",
  },
  {
    id: 15,
    category: "Assurance & assistance",
    question: "Que faire en cas de problème ou panne sur la route ?",
    answer:
      "En cas d'incident pendant votre location, une synthèse des actions à mener et une fiche de contact vous sera transmise — chaque plateforme dispose de leur propre assistance, en général complète : véhicule de remplacement, rapatriement, dépannage sur place... Vous pouvez biensur nous joindre par téléphone pour toute question pratique sur le véhicule.",
  },
];

const categories = Array.from(new Set(faqData.map((item) => item.category)));

export default function FAQ() {
  const [openId, setOpenId] = useState<number | null>(null);
  const [activeCategory, setActiveCategory] = useState<string>("Tous");

  const toggle = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  const filtered =
    activeCategory === "Tous"
      ? faqData
      : faqData.filter((item) => item.category === activeCategory);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero */}
      <div className="bg-[#1E585A] py-16 px-4 text-center">
        <h1
          className="text-4xl font-bold text-white mb-4"
          style={{ fontFamily: "Quicksand, sans-serif" }}
        >
          Questions fréquentes
        </h1>
        <p
          className="text-[#87CEB7] text-lg max-w-xl mx-auto"
          style={{ fontFamily: "Quicksand, sans-serif" }}
        >
          Tout ce que vous devez savoir avant de partir à l'aventure.
        </p>
      </div>

      <div className="max-w-3xl mx-auto px-4 py-12">
        {/* Filtres par catégorie */}
        <div className="flex flex-wrap gap-2 mb-10 justify-center">
          {["Tous", ...categories].map((cat) => (
            <button
              key={cat}
              onClick={() => {
                setActiveCategory(cat);
                setOpenId(null);
              }}
              className="px-4 py-2 rounded-full text-sm font-semibold transition-all duration-200"
              style={{
                fontFamily: "Quicksand, sans-serif",
                backgroundColor:
                  activeCategory === cat ? "#1E585A" : "#f0faf8",
                color: activeCategory === cat ? "white" : "#1E585A",
                border: "2px solid #1E585A",
              }}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* FAQ items */}
        <div className="space-y-3">
          {filtered.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className="rounded-2xl border overflow-hidden transition-all duration-200"
                style={{
                  borderColor: isOpen ? "#1E585A" : "#e5e7eb",
                  boxShadow: isOpen
                    ? "0 4px 16px rgba(30,88,90,0.10)"
                    : "none",
                }}
              >
                <button
                  onClick={() => toggle(item.id)}
                  className="w-full flex items-center justify-between px-6 py-5 text-left"
                  style={{
                    backgroundColor: isOpen ? "#f0faf8" : "white",
                    fontFamily: "Quicksand, sans-serif",
                  }}
                >
                  <span
                    className="text-base font-bold pr-4"
                    style={{ color: "#1E585A" }}
                  >
                    {item.question}
                  </span>
                  <span
                    className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300"
                    style={{
                      backgroundColor: isOpen ? "#1E585A" : "#e5f5f1",
                      transform: isOpen ? "rotate(45deg)" : "rotate(0deg)",
                    }}
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 2V12M2 7H12"
                        stroke={isOpen ? "white" : "#1E585A"}
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </span>
                </button>

                {/* Réponse animée */}
                <div
                  style={{
                    maxHeight: isOpen ? "500px" : "0px",
                    overflow: "hidden",
                    transition: "max-height 0.35s cubic-bezier(0.4,0,0.2,1)",
                  }}
                >
                  <div
                    className="px-6 pb-5 pt-1 text-sm leading-relaxed"
                    style={{
                      color: "#374151",
                      fontFamily: "Quicksand, sans-serif",
                      borderTop: "1px solid #e5f5f1",
                    }}
                  >
                    {item.answer}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA bas de page */}
        <div
          className="mt-14 rounded-2xl p-8 text-center"
          style={{ backgroundColor: "#f0faf8" }}
        >
          <p
            className="text-lg font-bold mb-2"
            style={{ color: "#1E585A", fontFamily: "Quicksand, sans-serif" }}
          >
            Vous n'avez pas trouvé votre réponse ?
          </p>
          <p
            className="text-sm mb-5"
            style={{ color: "#6b7280", fontFamily: "Quicksand, sans-serif" }}
          >
            Notre équipe est disponible par téléphone et via le formulaire de
            contact pour répondre à toutes vos questions.
          </p>
          <a
            href="/contact"
            className="inline-block px-7 py-3 rounded-full font-bold text-sm text-white transition-opacity hover:opacity-90"
            style={{
              backgroundColor: "#E36414",
              fontFamily: "Quicksand, sans-serif",
            }}
          >
            Nous contacter
          </a>
        </div>
      </div>
    </div>
  );
}
